module.exports = __webpack_public_path__ + "static/media/green_nebula_skybox_LF.3ee1682a.png";